import { render, staticRenderFns } from "./GraficoBarras.vue?vue&type=template&id=0f56043d"
import script from "./GraficoBarras.vue?vue&type=script&lang=js"
export * from "./GraficoBarras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports